import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const STORAGE_KEY = 'cookie-consent-v1';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const accepted = localStorage.getItem(STORAGE_KEY);
      if (!accepted) {
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch { /* noop */ }
  }, []);

  const accept = () => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() })); }
    catch { /* noop */ }
    setVisible(false);
    window.dispatchEvent(new Event('cookie-consent-accepted'));
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-3 bottom-3 md:inset-x-auto md:right-6 md:bottom-6 z-50 max-w-md bg-white rounded-2xl shadow-2xl border-2 border-sky-200 p-5 md:p-6"
      role="dialog"
      aria-label="Cookie-Hinweis"
      data-testid="cookie-consent"
    >
      <div className="flex items-start gap-3 mb-3">
        <div className="text-3xl">🍪</div>
        <div>
          <h3 className="font-bold text-sky-900 mb-1">Hinweis zu Cookies</h3>
          <p className="text-sm text-neutral-600">
            Wir verwenden ausschließlich <strong>technisch notwendige Cookies</strong> (z. B. zur Anmeldung am Kundenkonto). Zusätzlich messen wir die Reichweite unserer Seite <strong>vollständig anonym</strong> (keine Cookies, kein Personenbezug, keine Weitergabe an Drittanbieter).
          </p>
        </div>
      </div>
      <div className="flex flex-col-reverse sm:flex-row gap-2">
        <Button asChild variant="outline" className="rounded-full" data-testid="cookie-details">
          <Link to="/datenschutz">Datenschutzerklärung</Link>
        </Button>
        <Button
          onClick={accept}
          data-testid="cookie-accept"
          className="bg-sky-600 hover:bg-sky-700 text-white rounded-full flex-1"
        >
          Verstanden
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;
